import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { ValidationService } from '../validation.service'
import{Router} from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html',
  styleUrls: ['./step4.component.css']
})
export class Step4Component implements OnInit {
  stampDutyLandTax: string = "";
  loanOriginationFee: string = "";
  calcData: any;
  lat: number = 0;
  long: number = 0;
  country: string = "";
  PropertyValue: string = "";
  letteingManagFee: string = "";
  serviceCharges: string = "";
  miscelleneousExpense: string = "";
  legalFees: string = "";
  rentalGrowthEscalation: string = "";
  PropertyLondon: any;
  City: string = '';

  // Computed display values for left panel
  processingFeeAmount: string = "";
  acquisitionTotal: string = "";
  runningCostTotal: string = "";
  year1Total: string = "";

  // Mobile accordion state
  acqOpen = false;
  runningOpen = false;

  constructor(
    private router: Router,
    private dataService: DataService,
    public validation: ValidationService
  ) {
    this.calcData = JSON.parse(localStorage.getItem("calcData") || '{}');

    if (!this.dataService.EmptyNullOrUndefined(this.calcData.stampDutyLandTax)) {
      this.stampDutyLandTax = this.validation.amountWithComma(this.calcData.stampDutyLandTax);
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.loanOriginationFee)) {
      this.loanOriginationFee = this.calcData.loanOriginationFee + '%';
    }
    if (this.calcData.optmortgage === "0") {
      this.loanOriginationFee = "0";
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.lat)) {
      this.lat = this.calcData.lat;
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.long)) {
      this.long = this.calcData.long;
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.Country)) {
      this.country = this.calcData.Country;
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.PropertyValue)) {
      this.PropertyValue = this.calcData.PropertyValue;
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.City)) {
      this.City = this.calcData.City;
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.letteingManagFee)) {
      this.letteingManagFee = this.calcData.letteingManagFee + '%';
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.serviceCharges)) {
      this.serviceCharges = this.validation.amountWithComma(this.calcData.serviceCharges);
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.miscelleneousExpense)) {
      this.miscelleneousExpense = this.validation.amountWithComma(this.calcData.miscelleneousExpense);
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.legalFees)) {
      this.legalFees = this.validation.amountWithComma(this.calcData.legalFees);
    }
    if (!this.dataService.EmptyNullOrUndefined(this.calcData.rentalGrowthEscalation)) {
      this.rentalGrowthEscalation = this.calcData.rentalGrowthEscalation;
    }
  }

  // Map any city/region name to valid propertydata.co.uk country param
  resolveApiCountry(raw: string): string {
    if (!raw) return 'england';
    const r = raw.toLowerCase().trim();
    if (r === 'scotland') return 'scotland';
    if (r === 'wales') return 'wales';
    if (r === 'northern-ireland' || r === 'northern ireland') return 'northern-ireland';
    // All UK cities (Manchester, Birmingham, Liverpool, etc.) are in England
    return 'england';
  }

  // UK SDLT calculator — April 2025 bands
  // buyerType: 'ftb' (first time buyer) | 'investment' (additional dwelling)
  calculateSdltFallback(value: number, isForeignBuyer: boolean, buyerType: string): number {
    let sdlt = 0;

    if (buyerType === 'ftb' && value <= 500000) {
      // FTB relief: 0% up to £300k, 5% on £300k–£500k
      if (value > 300000) sdlt = (value - 300000) * 0.05;
    } else if (buyerType === 'ftb') {
      // FTB > £500k loses relief — standard bands apply
      if (value > 125000) sdlt += Math.min(value - 125000, 125000) * 0.02;
      if (value > 250000) sdlt += Math.min(value - 250000, 675000) * 0.05;
      if (value > 925000) sdlt += Math.min(value - 925000, 575000) * 0.10;
      if (value > 1500000) sdlt += (value - 1500000) * 0.12;
    } else {
      // Investment / additional dwelling: standard bands + 5% ADS on every £
      sdlt = value * 0.05;
      if (value > 125000) sdlt += Math.min(value - 125000, 125000) * 0.02;
      if (value > 250000) sdlt += Math.min(value - 250000, 675000) * 0.05;
      if (value > 925000) sdlt += Math.min(value - 925000, 575000) * 0.10;
      if (value > 1500000) sdlt += (value - 1500000) * 0.12;
    }

    // Non-resident surcharge: +2% of full property value
    if (isForeignBuyer) sdlt += value * 0.02;

    return Math.round(sdlt);
  }

  ngOnInit(): void {
    this.PropertyLondon = localStorage.getItem("PropertyLondon");

    // Pre-fill defaults if not already set
    if(!this.loanOriginationFee && this.calcData?.optmortgage !== '0') this.loanOriginationFee = '0';
    if(!this.legalFees) this.legalFees = '1,500';
    if(!this.miscelleneousExpense) this.miscelleneousExpense = '0';
    if(!this.letteingManagFee) this.letteingManagFee = this.PropertyLondon == 1 ? '12%' : '10%';
    if(!this.serviceCharges) this.serviceCharges = this.autoServiceCharge();

    const apiCountry = this.resolveApiCountry(this.country);

    const isForeignBuyer = this.calcData.ForeignBuyer === '1';
    const buyerType = this.calcData.BuyerType || 'investment';
    // 'first_time' gives FTB relief; 'investment' gives standard + 5% ADS
    const apiMode = buyerType === 'ftb' ? 'first_time' : 'investment';
    this.dataService.GetRequest(
      'https://api.propertydata.co.uk/stamp-duty-calculator?key=' + environment.PropertyDataKey +
      '&value=' + this.PropertyValue + '&country=' + apiCountry + '&mode=' + apiMode
    ).subscribe((res: Response) => {
      var obj = JSON.parse(JSON.stringify(res));
      if (obj.status === "success") {
        let sdlt = parseFloat(obj.transaction_tax_payable);
        // API handles base rates; add 2% non-resident surcharge manually if needed
        if (isForeignBuyer) {
          sdlt += parseFloat(this.PropertyValue) * 0.02;
        }
        this.stampDutyLandTax = this.validation.amountWithComma(Math.round(sdlt).toString());
        this.calcTotals();
      } else {
        // API failed — use built-in calculator
        const propVal = parseFloat(this.PropertyValue) || 0;
        const sdlt = this.calculateSdltFallback(propVal, isForeignBuyer, buyerType);
        this.stampDutyLandTax = this.validation.amountWithComma(sdlt.toString());
        this.calcTotals();
      }
    }, () => {
      // HTTP error — use built-in calculator
      const propVal = parseFloat(this.PropertyValue) || 0;
      const sdlt = this.calculateSdltFallback(propVal, isForeignBuyer, buyerType);
      this.stampDutyLandTax = this.validation.amountWithComma(sdlt.toString());
      this.calcTotals();
    });
  }

  onFeeChange() {
    this.calcTotals();
  }

  calcTotals() {
    const sdlt = parseFloat((this.stampDutyLandTax || '0').replace(/,/g, '')) || 0;
    const propVal = parseFloat((this.PropertyValue || '0').replace(/,/g, '')) || 0;
    const feeRate = parseFloat((this.loanOriginationFee || '0').replace('%', '')) || 0;
    const loanAmt = propVal * (parseFloat(this.calcData.loanAmount || '0') / 100);
    const procFee = loanAmt * (feeRate / 100);
    this.processingFeeAmount = procFee > 0 ? this.validation.amountWithComma(Math.round(procFee).toString()) : '0';

    const legal = parseFloat((this.legalFees || '0').replace(/,/g, '')) || 0;
    const acqTotal = sdlt + procFee + legal;
    this.acquisitionTotal = acqTotal > 0 ? this.validation.amountWithComma(Math.round(acqTotal).toString()) : '';

    const svcCharges = parseFloat((this.serviceCharges || '0').replace(/,/g, '')) || 0;
    const misc = parseFloat((this.miscelleneousExpense || '0').replace(/,/g, '')) || 0;
    const annualTotal = svcCharges + misc;
    this.runningCostTotal = annualTotal > 0 ? this.validation.amountWithComma(Math.round(annualTotal).toString()) : '';

    const yr1 = acqTotal + annualTotal;
    this.year1Total = yr1 > 0 ? this.validation.amountWithComma(Math.round(yr1).toString()) : '';
  }

  autoServiceCharge(): string {
    const pv = parseFloat((this.PropertyValue + '').replace(/,/g, '')) || 0;
    const charge = pv < 360000 ? 3.5 * 500 : 3.5 * 750;
    return this.validation.amountWithComma(charge.toString());
  }

  next() {
    this.calcData.stampDutyLandTax = this.stampDutyLandTax ? this.stampDutyLandTax.replace(/,/g, '') : '0';
    this.calcData.loanOriginationFee = (this.loanOriginationFee || '0').replace('%', '');
    this.calcData.letteingManagFee = (this.letteingManagFee || '0').replace('%', '');
    this.calcData.serviceCharges = this.serviceCharges ? this.serviceCharges.replace(/,/g, '') : '0';
    this.calcData.miscelleneousExpense = this.miscelleneousExpense ? this.miscelleneousExpense.replace(/,/g, '') : '0';
    this.calcData.legalFees = this.legalFees ? this.legalFees.replace(/,/g, '') : '0';
    this.calcData.reportSavedOnServer = false;
    localStorage.setItem("calcData", JSON.stringify(this.calcData));
    this.router.navigate(['/calculated-irr']);
  }
}
